<template>
  <form-page-template
      :dirty="dirty"
      @save="doSave"
      maximizable>
    <template #toolbar-items>
<!--      <edit-toggle-button-->
<!--          component-name="ServiceComponentModel"-->
<!--          v-if="!isCategory2nd('external')">-->
<!--      </edit-toggle-button>-->
      <v-toolbar-title class="with-divider">
        {{ dictionary.name }} - {{ serviceComponentModel.name }}
      </v-toolbar-title>
    </template>

    <template>
      <v-row dense>
        <v-col cols="12" md="2">
          <hds-id-field
              v-model="serviceComponentModel.id"
              label="ID"
              hide-details/>
        </v-col>
        <v-col cols="12" md="10">
          <v-text-field
              v-if="isEditable"
              v-model="serviceComponentModel.name"
              label="サービス構成モデル名"
              :readonly="!isEditable"
              :rules="[v => !!v || 'サービス構成モデル名が必要です']"
              autofocus>
          </v-text-field>
          <text-field-like
              v-else
              :value="serviceComponentModel.name"
              label="サービス構成モデル名"
              hide-details>
          </text-field-like>
        </v-col>
        <v-col cols="12" v-if="isCategory2nd('common')">
          <category-select
              v-model="serviceComponentCategories"
              item-text="name"
              item-value="id"
              :return-object="false"
              label="カテゴリ"
              :readonly="!isEditable"
              :hide-details="!isEditable"
              placeholder="未選択"
              required
              multiple
              chips small-chips>
          </category-select>
        </v-col>
        <v-col cols="12">
          <v-textarea
              v-if="isEditable"
              v-model="serviceComponentModel.description"
              label="説明"
              messages="複数行入力可"
              rows="1"
              auto-grow
              required>
          </v-textarea>
          <text-field-like
              v-else
              :value="serviceComponentModel.description"
              label="説明"
              placeholder="未設定"
              hide-details
              multi-line>
          </text-field-like>
        </v-col>
      </v-row>
    </template>

    <!-- 参照先共通辞書編集 -->
    <template #after-form v-if="!isCategory2nd('common')">
      <v-container>
        <v-card outlined>
          <v-card-title style="padding-bottom: 0;">共通辞書</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="4" md="2">
                <hds-id-field
                    :value="selectedDictionary.id"
                    label="共通辞書ID"
                    hide-details
                ></hds-id-field>
              </v-col>
              <v-col cols="8" md="3">
                <text-field-like
                    label="共通辞書名"
                    :value="selectedDictionary.name"
                    hide-details>
                  <template #default="{value}">
                    <deletable-field :value="value" :deleted="selectedDictionary.isDeleted"/>
                  </template>
                </text-field-like>
              </v-col>
              <v-col cols="4" md="3">
                <hds-id-field
                    :value="selectedServiceComponentModel.id"
                    label="選択されているサービス構成モデルID"
                    hide-details
                ></hds-id-field>
              </v-col>
              <v-col cols="8" md="4">
                <text-field-like
                    :value="selectedServiceComponentModel.name"
                    label="選択されているサービス構成モデル名"
                    hide-details
                ></text-field-like>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
    </template>

    <template #tab-items>
      <v-tab :to="{...$route, name: alterRouteName('./processComponentModels')}">
        <span>プロセス構成モデル</span>
        <error-icon small :level="errorLevels.processComponentModel"></error-icon>
      </v-tab>

      <v-tab :to="{...$route, name: alterRouteName('./processOperations')}">
        <span>プロセス手順定義</span>
        <error-icon small :level="errorLevels.processOperationList"></error-icon>
      </v-tab>
    </template>

    <template #after-tabs>
      <router-view
          :dictionary="dictionary"
          :service-component-model="serviceComponentModel"
          :selected-dictionary="selectedDictionary"
          :selected-data-component-model="selectedDataComponentModel"
          @update-error-level="updateErrorLevel"
          @dirty="markDirty">
      </router-view>
    </template>
  </form-page-template>
</template>

<script>
import Vue from "vue";
import PathInfoMixin from "@/router/PathInfoMixin";
import {IoableParentPageMixin} from "@/router/IoablePageMixin";
import CategorySelect from "@/components/molecules/CategorySelect.vue";
import BetterSet from "betterset";
import HdsIdField from "@/components/molecules/HdsIdField.vue";
import {mapActions, mapGetters, mapMutations} from "vuex";
import query from "@/gql/ServiceComponentModel/Query.gql";
import mutation from "@/gql/ServiceComponentModel/Update.gql";
import FormPageTemplate from "@/components/templates/FormPageTemplate.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import DeletableField from "@/components/molecules/DeletableField.vue";
import ErrorIcon from "@/components/molecules/ErrorIcon.vue";
import {safeMeta} from "@/router/Meta";
import deepEquals from "fast-deep-equal";
import ErrorBuilderMixin from "@/components/pages/dictionary/Dictionary/ErrorBuilderMixin";
import groupArray from "group-array";
import {maxErrorLevel} from "@/components/molecules/ErrorMessage";

export default {
  name: 'ServiceComponentModel',
  components: {
    ErrorIcon,
    DeletableField,
    TextFieldLike, FormPageTemplate, HdsIdField, CategorySelect
  },
  mixins: [
    PathInfoMixin,
    IoableParentPageMixin.extend({
      beforeRouteUpdate(to, from, next) {
        next();
        if(to.hash !== from.hash ||
            !deepEquals(to.params, from.params)) {
          this.$nextTick(() => {
            this.doLoad();
          });
        }
      },
    }),
    ErrorBuilderMixin,
  ],
  props: {
    dictionaryId: String,
    serviceComponentModelId: String
  },
  data() {
    return {
      valid: false,
      errorLevels: {
        processComponentModel: '',
        processOperationList: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      entities: 'hds/entities',
      client: 'hds/gqlClient',
      db: 'hds/db',
    }),
    dictionary() {
      return Vue.observable(
          this.entities.dictionary.findOne({id: this.dictionaryId})) || {id: this.dictionaryId};
    },
    serviceComponentModel() {
      return Vue.observable(
          this.entities.serviceComponentModel.findOne({id: this.serviceComponentModelId})) || {id: this.serviceComponentModelId};
    },
    serviceComponentCategories: {
      get() {
        return this.serviceComponentModel.categories || [];
      },
      set(newCategories) {
        const prevSet = new BetterSet(this.serviceComponentCategories);
        const nextSet = new BetterSet(newCategories);
        if (!prevSet.equals(nextSet)) {
          this.serviceComponentModel.categories = nextSet.asArray();
          this.markDirty();
        }
      }
    },
    selectedServiceComponentModel() {
      const serviceTranslationMap = this.entities.serviceTranslationMap.findOne({'targetDictionary.id': this.selectedDictionaryId});
      if (serviceTranslationMap) {
        return serviceTranslationMap.targetServiceComponentModel;
      } else {
        return {};
      }
    },
    selectedDictionary() {
      const serviceTranslationMap = this.entities.serviceTranslationMap.findOne({'targetDictionary.id': this.selectedDictionaryId});
      if (serviceTranslationMap) {
        return serviceTranslationMap.targetDictionary;
      } else {
        return {};
      }
    },
    selectedDataComponentModel() {
      if(this.selectedDataComponentModelId) {
        return this.entities.dataComponentModel.findOne({id: this.selectedDataComponentModelId});
      } else {
        return null;
      }
    },
    selectedDictionaryId() {
      return this.$route.query?.selectedDictionary;
    },
    selectedDataComponentModelId() {
      return this.$route.query?.selectedDataComponentModel ?? null;
    },
    backButtonTo() {
      if(this.selectedDataComponentModelId) {
        return {
          name: this.alterRouteName('DataComponentModel/processOperations'),
          params: {
            dictionaryId: this.dictionary.id,
            dataComponentModelId: this.selectedDataComponentModelId
          },
          query: {
            selectedDictionary: this.selectedDictionaryId,
          }
        };
      }

      return {
        name: safeMeta(this.$route).parent,
        query: this.$route.query
      };
    },
  },
  methods: {
    ...mapMutations({
      showSnackbar: 'showSnackbar'
    }),
    ...mapActions({
      gqlQueryAndLoad: 'hds/gqlQueryAndLoad',
      gqlMutate: 'hds/gqlMutate'
    }),

    async load() {
      await this.gqlQueryAndLoad({
        clear: true,
        query,
        variables: {
          dictionaryId: this.dictionaryId,
          serviceComponentModelId: this.serviceComponentModelId
        },
        mapping: {
          dictionary: 'dictionary',
          category: 'dictionary.categories > id',
          dataComponentModel: 'dictionary.dataComponentModels > id',
          serviceComponentModel: 'serviceComponentModel',
          processComponentModel: 'serviceComponentModel.processComponentModels > id',
          processOperation: 'serviceComponentModel.processComponentModels.processOperations > id+',
          serviceTranslationMap: 'serviceComponentModel.serviceTranslationMaps'
        }
      });

      this.updateErrorLevel();
    },

    save() {
      this.entities.serviceComponentModel.update(this.serviceComponentModel);
      const scmDelta = this.entities.serviceComponentModel.getDelta({
        update: [
          'id', 'name', 'description',
          {
            name: 'categoryIds',
            source: 'categories'
          }
        ]
      });
      const pcmDelta = this.entities.processComponentModel.getDelta({
        update: [
          'id', 'name', 'description', 'index',
          {
            name: 'processOperations',
            source: row => this.entities.processOperation
                .find({processComponentModelId: row.id})
                .map(po => ({
                  dataComponentModelId: po.dataComponentModelId,
                  description: po.description,
                  index: po.index,
                  operationType: po.operationType
                }))
          }
        ]
      });
      return this.gqlMutate({
        mutation,
        variables: {
          updateServiceComponentModels: scmDelta.update,
          updateProcessComponentModels: pcmDelta.update
        }
      });
    },
    isTransitionPermitted(destination, route) {
      if(destination === 'edit') {
        const account = this.$store.getters['hcs/account'];
        if (!account.user || !account.owner) {
          return false;
        }
        return account.owner.id === this.dictionary.ownerId && !this.dictionary.isPublished;
      }
    },
    updateErrorLevel() {
      const errors = this.buildServiceComponentModelError(this.serviceComponentModel);
      const groupedErrors = Object.values(groupArray(errors, 'type'));
      this.errorLevels = Object.fromEntries(groupedErrors.map(group => {
        const first = group[0];
        if(first === undefined) {
          return undefined;
        }
        return [first.type, maxErrorLevel(group)];
      }));
    },
  },
  watch: {
    serviceComponentModel: {
      handler() {
        this.markDirty();
      },
      deep: true
    },
  }
}
</script>

<style lang="scss" scoped>
span.index {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  display: inline-block;
  vertical-align: middle;
  line-height: 50px;
  height: 50px;
}

$border-color: #888;

::v-deep {
  .el-table {
    .el-table__expanded-cell {
      padding: 10px 20px;
    }
  }
}
</style>
